export const URLS = {
    pwd: window.location.href,
    homepage: '/',
    auth: {
        check: '/auth',
        login: '/auth',
        register: '/auth/register',
        logout: '/auth/logout',
        recovery: '/auth/recovery',
        otp: '/auth/otp/{mobile}/{otpToken}',
    },
    lms: {
        dashboard: '/lms',
        groups: '/lms',
        levels: '/lms/group',
        levelView: '/lms/level',
    },
    student: {
        dashboard: '/student',
        profile: {
            dashboard: '/student/profile',
            edit: '/student/profile/edit',
        },
        certifications: {
            dashboard: '/student/certifications',
        },
        survey: {
            certificate: '/student/survey/certificate/{id}',
            publicSurvey: '/student/survey/list',
            publicSurveyAnswer: '/student/survey/list/{id}',
        },
        billing: {
            dashboard: '/student/billing/',
            refund: '/student/billing/refund',
        },
        installments: {
            dashboard: '/student/installments/',
        },
        lessons: {
            chooseGrade: '/student/lessons/take-grade',
            dashboard: '/student/lessons/',
            take: '/student/lessons/take',
            map: '/student/lessons/map',
            takeLesson: '/student/lessons/take/{id}',
            exam: '/student/lessons/exam/{id}',
            myLesson: {
                list: '/student/lessons/my-lesson',
                detail: '/student/lessons/my-lesson/{id}',
                homework: '/student/lessons/my-lesson/{id}/homework/{homeworkId}',
            },


        },
        scores: {
            dashboard: '/student/scores/',
        },
        absences: {
            dashboard: '/student/absences',
        }


    },
    admin: {
        dashboard: '/admin',
        refund: {
            dashboard: '/admin/refund',
            items: '/admin/refund/items',
            view: '/admin/refund/edit/{id}',
            group : {
                list:   '/admin/refund/groups',
                create: '/admin/refund/groups/create',
                edit: '/admin/refund/groups/edit/{id}',
            }
        },
        exports: {
            dashboard: '/admin/setting/exports',


        },
        topic: {
            dashboard: '/admin/topics',
            view: '/admin/topics/{id}',

        },
        products: {
            dashboard: '/admin/products',
            list: '/admin/products/list',
            delivery : {
                create: '/admin/products/delivery/create',
                edit: '/admin/products/delivery/{id}',
                list: '/admin/products/delivery',
                deliver: '/admin/products/delivery/deliver',
                deliverToLesson: '/admin/products/delivery/deliver/lesson',
                printToLesson: '/admin/products/delivery/deliver/receipt-lesson',
                category: '/admin/products/delivery/category/{category}',
                categoryFull: '/admin/products/delivery/category',
                receipt: '/admin/products/delivery/receipt',
                searchForPrint: '/admin/products/delivery/search',
                searchForDeliver: '/admin/products/delivery/deliver',
            },
            create: '/admin/products/create',
            edit: '/admin/products/{id}',
            members: '/admin/products/members',
        },
        members: {
            dashboard: '/admin/members',
            list: '/admin/members/list',
            edit: '/admin/members/{id}',
        },
        poll: {
            dashboard: '/admin/poll',
            create: '/admin/poll/create',
        },
        import: {
            dashboard: '/admin/setting/imports',
            create: '/admin/setting/imports/create',
        },
        survey: {
            dashboard: '/admin/survey',
            create: '/admin/survey/create',
            result: '/admin/survey/result',
            edit: '/admin/survey/edit/{id}',
        },
        classroom: {
            dashboard: '/admin/classroom',
            map: '/admin/classroom/map',
            create: '/admin/classroom/create',
            result: '/admin/classroom/result',
            edit: '/admin/classroom/edit/{id}',
        },
        discount: {
            dashboard: '/admin/discount',
            create: '/admin/discount/create',
            list: '/admin/discount/list',
            edit: '/admin/discount/edit/{id}',
        },
        setting: {
            dashboard: '/admin/setting',
            system: '/admin/setting/system',
            sms: '/admin/setting/sms',
            academy: '/admin/setting/academy',
            refund: '/admin/setting/refund',
        },
        roles: {
            dashboard: '/admin/roles',
            edit: '/admin/roles/{id}',
        },
        group: {
            list: '/admin/groups',
            create: '/admin/groups/create',
            edit: '/admin/groups/edit/{id}',
        },
        grade: {
            list: '/admin/grades',
            create: '/admin/grades/create',
            edit: '/admin/grades/edit/{id}',
        }
    },
    gateway: {
        selector: '/gateway',
        selectChildren: '/gateway/children',
    },
    teacher: {
        dashboard: '/teacher',
        profile: {
            dashboard: '/teacher/profile',
            edit: '/teacher/profile/edit',
        },
        weekly: {
            dashboard: '/teacher/weekly',
        },
        lessons: {
            dashboard: '/teacher/lessons',
            detail: '/teacher/lessons/{id}',
            students: '/teacher/lessons/{id}/students',
            studentsDetail: '/teacher/lessons/{id}/students/{studentId}',
            score: '/teacher/lessons/{id}/score',
            homeworks: '/teacher/lessons/{id}/homeworks',
            homeworksCreate: '/teacher/lessons/{id}/homeworks/create',
            homeworksUpdate: '/teacher/lessons/{id}/homeworks/{homeworkId}',
            attendance: '/teacher/lessons/{id}/attendance',
            moderator: '/teacher/lessons/{id}/moderator',
            print: '/teacher/lessons/{id}/print',
        },
        reports: {
            dashboard: '/teacher/reports',
            create: '/teacher/reports/create',
        },
        times: {
            dashboard: '/teacher/times',
        },
        homeworks: {
            dashboard: '/teacher/homeworks',
            reports: '/teacher/homeworks',
            reportsEdit: '/teacher/homeworks/{id}',
            create: '/teacher/homeworks/create',
        }
    },
    notification: {
        student: '/student/notifications',
        teacher: '/teacher/notifications',
        admin: '/admin/notifications',
    }
}


